'use client';

import { ResetPage } from '@/components/ResetPage';
import { useRollbar } from '@rollbar/react';
import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const rollbar = useRollbar();

  useEffect(() => {
    rollbar.error(error); // report error to Rollbar
  }, [error, rollbar]);

  return <ResetPage reset={reset} />;
}
